import { NetworkId } from 'thales-utils'
import type { SupportedNetwork } from '../types/network'

export const LOCAL_STORAGE_KEYS = {
  UI_THEME: 'ui-theme',
  FILTER_STATUS: 'filterStatus',
  FILTER_MARKET_SEARCH: 'filterMarketSearch',
  FILTER_TAGS: 'tagsFilter',
  FILTER_DATE_PERIOD: 'filterDatePeriod',
  FILTER_SPORT: 'filterSport',
  FILTER_ACTIVE: 'filterActive',
  FILTER_TOURNAMENT: 'filterTournament',
  ODDS_TYPE: 'typeOdds',
  STOP_PULSING: 'stopPulsing',
  FAVOURITE_LEAGUES: 'favouriteLeaguesV2',
  PARLAY: 'parlay',
  COMBINED_POSITIONS: 'combinedPositions',
  COLLATERAL_INDEX: 'collateralIndex',
  KEEP_SELECTION: 'keepSelection',
  IS_THREE_WAY_VIEW: 'isThreeWayView',
  SORT_TYPE: 'sortType',
  LIVE_BET_SLIPPAGE: 'liveBetSlippage',
  COLLATERAL_CHANGED: 'collateralChanged',
  OVERDROP_PREVENT_DAILY_MODAL: 'overdropPreventDailyModal',
  OVERDROP_STATE: 'overdropState',
  SESSION_P_KEY: {
    [NetworkId.OptimismMainnet]: 'sessionPKey_10',
    [NetworkId.Arbitrum]: 'sessionPKey_42161',
    [NetworkId.Base]: 'sessionPKey_8453',
    [NetworkId.OptimismSepolia]: 'sessionPKey_11155420',
  } as Record<SupportedNetwork, string>,
  IS_SYSTEM_BET: 'isSystemBet',
  IS_SGP: 'isSGP',
  SYSTEM_BET_DENOMINATOR: 'systemBetDenominator',
  ERROR_RELOAD_TIME: 'errorReloadTime',
  USE_BICONOMY: 'isBiconomy',
  FREE_BET_ID: 'freeBetId',
  TERMS_AND_CONDITIONS: 'terms&Conditions',
  SHOW_ZERO_BALANCE: 'showZeroBalance',
}
